module.exports = __webpack_public_path__ + "static/media/191IT255.bccdf43d.jpg";